import { DashboardLayoutDefinition } from './types-store';

/** 
 * ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
 * They do not themselves have any side-effects; they just describe something that is going to happen.
 * Use @typeName and isActionType for type detection that works even after serialization/deserialization.
 */

export const ACTION = {
  INCREASE_EXECUTION_COUNTER: 'DASHBOARD:INCREASE_EXECUTION_COUNTER',
  REQUEST_CONTAINER_DEFINITIONS: 'DASHBOARD:REQUEST_CONTAINER_DEFINITIONS',
  RECEIVE_CONTAINER_DEFINITIONS: 'DASHBOARD:RECEIVE_CONTAINER_DEFINITIONS',
  FAILED_CONTAINER_DEFINITIONS: 'DASHBOARD:FAILED_CONTAINER_DEFUINITIONS',
  REQUEST_MAIN_FAVOURITE: 'DASHBOARD:REQUEST_MAIN_FAVOURITE',
  RECEIVE_MAIN_FAVOURITE: 'DASHBOARD:RECEIVE_MAIN_FAVOURITE',
  CLEAR_MAIN_FAVOURITE: 'DASHBOARD:CLEAR_MAIN_FAVOURITE',
  FAILED_MAIN_FAVOURITE: 'DASHBOARD:FAILED_MAIN_FAVOURITE'
};

export class IncreaseExecutionCounter {
  public type: string = ACTION.INCREASE_EXECUTION_COUNTER;
}

export class RequestContainerDefinitions {
  public type: string = ACTION.REQUEST_CONTAINER_DEFINITIONS;
  public dashboardType: number;

  constructor(dashboardType: number) {
    this.dashboardType = dashboardType;
  }
}

export class ReceiveContainerDefinitions {
  public type: string = ACTION.RECEIVE_CONTAINER_DEFINITIONS;
  constructor(public dashboardType: number, public dashboardDefinition: DashboardLayoutDefinition) {}
}

export class FailedContainerDefinitions {
  public type: string = ACTION.FAILED_CONTAINER_DEFINITIONS;

  constructor(public dashboardType: number) {}
}

export class RequestMainFavourite {
  public type: string = ACTION.REQUEST_MAIN_FAVOURITE;
}

export class ReceiveMainFavourite {
  public type: string = ACTION.RECEIVE_MAIN_FAVOURITE;
  constructor(public mainFavouriteId: number) {}
}
export class ClearMainFavourite {
  public type: string = ACTION.CLEAR_MAIN_FAVOURITE;
}

export class FailedMainFavourite {
  public type: string = ACTION.FAILED_MAIN_FAVOURITE;
  public mainFavouriteId: number;

  constructor(mainFavouriteId: number) {
    this.mainFavouriteId = mainFavouriteId;
  }
}
